<template>
  <div>
    <h2 class="text-h5 text-center mb-6">
      {{ title }}
    </h2>
    <Loader v-if="isLoading" text="" color="white"></Loader>
    <div v-if="showNoResults">No results found.</div>
    <div class="scrollable" v-if="!showNoResults && !isLoading">
      <ChartSelector
        v-for="(chart, index) in chartConfig"
        :key="index"
        :chart-config="chartConfig"
        :chart-uuid="chart.uuid"
        :config-type="configType"
        :charts-data="chartsData"
        :search-params="searchParams"
        :default-selected="chart"
      />
    </div>
  </div>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";
import lodashIsEmpty from "lodash/isEmpty";
import uuidV4 from "uuid/v4";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_SEARCH, MODULE_PREFIX_USER } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";
import { CHART_CONFIGS } from "@/common/constants/charts";

export default {
  name: "ChartsDisplay",
  components: {
    Loader: () => import("@/components/common/Loader"),
    ChartSelector: () => import("@/components/common/charts/ChartSelector"),
  },
  data: function () {
    return {
      chartConfig: {},
    };
  },
  mounted() {
    this.getChartConfig();
  },
  computed: {
    ...mapGetters({
      details: MODULE_PREFIX_SEARCH + "charts",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    title() {
      switch (this.configType) {
        case "security":
          return "Verified Security Event Trends";
        case "maritime":
          return "Verified Maritime Event Trends";
        default:
          return "Event Trends";
      }
    },
    configType() {
      return this.details.type;
    },
    chartsData() {
      return this.details.data;
    },
    searchParams() {
      return this.details.searchParams;
    },
    isLoading() {
      return this.chartsData?.loading;
    },
    showNoResults() {
      return lodashIsEmpty(this.chartsData) && !this.isLoading;
    },
  },
  methods: {
    getChartConfig() {
      let config = CHART_CONFIGS[this.configType];
      if (this.preferences?.liveSearch?.charts?.[this.configType]) {
        const orderedIds = this.preferences?.liveSearch?.charts?.[
          this.configType
        ];

        // Create a map of config objects by id for quick lookup
        const configMap = config.reduce((map, item) => {
          map[item.id] = item;
          return map;
        }, {});

        // Generate the final array
        config = orderedIds.map(({ id, defaultChartType }) => {
          if (configMap[id]) {
            return { ...configMap[id], defaultChartType };
          }
        });
      }

      // add a unique uuid for each if they don't already have one
      config.forEach((item) => {
        if (!item.uuid) {
          item.uuid = uuidV4();
        }
      });

      const preferences = lodashCloneDeep(this.preferences);
      preferences.liveSearch = preferences.liveSearch || {};
      preferences.liveSearch.charts = preferences.liveSearch.charts || {};
      preferences.liveSearch.charts[this.configType] = config;

      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, preferences);

      this.chartConfig = config;
    },
  },
};
</script>

<style>
.scrollable {
  height: calc(100vh - 50px); /* 50px for header */
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 60px;
}
</style>
